<template>
	<b-card>

		<p v-html="nl2br(question.content)"></p>

		<div v-if="!question.answered">
			<b-input-group class="col-12 col-sm-10 offset-sm-2 col-md-8 offset-md-4 col-lg-6 offset-lg-6 mb-2">
				<b-form-input v-model="question.userAnswer" type="text" placeholder="Lösung..." @keyup.enter="submitAnswer()"></b-form-input>
				<b-input-group-button slot="right">
					<b-button @click="submitAnswer()" :variant="'success'">lösen</b-button>
				</b-input-group-button>
			</b-input-group>

			<b-alert v-for="(tried, tey) in question.tryings" :key="tey" :variant="tried.type" show :dismissible="true">
				<strong>{{tried.answer}}</strong>
				<p v-html="nl2br(tried.message)"></p>
			</b-alert>
		</div>
		<div v-else class="text-right">
			<span class="badge badge-info">{{question.answer}} <i class="fa fa-check fa-fw"></i></span>
		</div>

		<!-- <p>{{question}}</p> -->
	<!-- <div class="row">
		<h3>Question</h3>
		<p>{{question}}</p>
		<b-button @click="answered">beantwortet</b-button>
	</div> -->
</b-card>
</template>

<script>
	export default {
		name: 'question-one',
		data () {
			return {}
		},
		// props: ['question', 'quizKey'],
		props: {
			question: {
				type: Object,
				required: true
			},
			questionKey: {
				type: Number,
				required: true
			}
			// quizKey: {
			// 	type: String,
			// 	required: true
			// },
			// questionKey: {
			// 	type: String,
			// 	required: true
			// }
		},
		updated(){
			// console.log('Question.vue was updated.')
		},
		mounted() {
			// console.log('I am mounted', this.question)
		},
		methods:{
			submitAnswer(){

				// let question = this.quiz.questions[key]
				let question = this.question
				this.$store.state.user.isAdmin && console.log('Erwarte antwort: ', question.answer)
				
				if(question.answer == question.userAnswer.replace(/,/g, '.')){
					this.$store.commit('questionAnswered', this.questionKey)
				}else{

					let tryType = 'danger'
					let message = 'Falsch.'

					question.alternatives && question.alternatives.forEach( (alternative, i) => {
						if(alternative.answer == question.userAnswer.replace(',', '.')){
							tryType = 'warning'
							message = alternative.message
						}
					})

					// this.quiz.questions[key].tryings.unshift({answer: question.userAnswer, type: tryType, message: message})
					// questions[key].tryings.unshift({answer: question.userAnswer, type: tryType, message: message})
					question.tryings.unshift({answer: question.userAnswer, type: tryType, message: message})
				}

				// this.$forceUpdate()
			}
		}
	}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// One.vue?61fec280